<template>
    <navbar position="fixed"
            type="primary"
            :transparent="transparent"
            :color-on-scroll="colorOnScroll"
            menu-classes="ml-auto"
            >
        <template slot-scope="{toggle, isToggled}">
            <router-link class="navbar-brand" to="/">
                Voice Sail Race Timer
            </router-link >
        </template>
        <template slot="navbar-menu">
          <router-link to="/beatlength/" class="nav-item">
            <i class="fas fa-calculator"></i>Beat Length Calculator
          </router-link>
            <router-link to="/remote-horn/" class="nav-item">
                <i class="fas fa-bullhorn"></i>Remote Horn
            </router-link>
            <router-link to="/documentation/" class="nav-item">
                <i class="fas fa-life-ring"></i>Documentation
            </router-link>
        </template>
    </navbar>
</template>

<script>
    import { Navbar, NavLink } from '@/components';
    import {Badge} from '@/components'
    export default {
        name: 'main-navbar',
        props: {
            transparent: Boolean,
            colorOnScroll: Number,
        },
        components: {
            Navbar,
            NavLink,
            Badge
        }
    }
</script>

<style lang="scss">
    a.nav-item {
        margin-left: 20px;
        i {
            margin-right: 5px;
        }
        text-transform: uppercase;
    }
</style>
